import SiteDetailView from './SiteDetailView';
import './SiteDetailView.scss';

export default SiteDetailView;
